exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-active[data-v-b22666fc] {\n  color: blue;\n}\n.el-submenu[data-v-b22666fc] {\n  border-radius: 20px;\n  overflow-wrap: break-word;\n  border: 2px solid #7fa3bb;\n  padding: 5px;\n}\n.el-submenu__title[data-v-b22666fc]:hover {\n    background-color: \"#b3c0d1\";\n}\n.el-menu-vertical-admin[data-v-b22666fc] {\n  margin: 5px;\n  word-wrap: break-word;\n  border-radius: 0px 20px;\n  border: 2px solid #7fa3bb;\n  padding: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b22666fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/RegistryAdminMenu.vue
// module id = pR/T
// module chunks = 1